import axios from 'axios';
import { Acknowledge } from 'components/Acknowledge';
import { BindPopup } from 'components/BindPopup';
import { CustomersHeader } from 'components/CompanyHeader';
import { Confirmation } from 'components/Confirmation';
import { Error } from 'components/Error';
import { ExpiredDocument } from 'components/ExpiredDocument';
import { Loading } from 'components/Loading';
import { Options } from 'components/Options';
import { Success } from 'components/Success';
import { Warning } from 'components/Warning';
import {
  AppNav,
  AuthContext,
  Header,
  User,
  useAPI,
  useLocation,
} from 'components/lib';
import { AgencyDocumentsModal } from 'components/modals/AgencyDocumentsModal';
import { CertificatesModal } from 'components/modals/CertificatesModal';
import { ChooseModal } from 'components/modals/ChooseModal';
import { CommodityModal } from 'components/modals/CommodityModal';
import { CompanyModal } from 'components/modals/CompanyModal';
import { ContactModal } from 'components/modals/ContactModal';
import { ContestModal } from 'components/modals/ContestModal';
import { DocumentsModal } from 'components/modals/DocumentsModal';
import { QuoteDocumentsModal } from 'components/modals/QuoteDocumentsModal';
import { DriversModal } from 'components/modals/DriversModal';
import { InvalidCommodity } from 'components/modals/InvalidCommodity';
import { EmailQuoteModal } from 'components/modals/EmailQuoteModal';
import { RunQuoteModal } from 'components/modals/RunQuoteModal';
import { RunPersonalQuoteModal } from 'components/modals/RunPersonalQuoteModal';
import { SubmitModal } from 'components/modals/SubmitQuote';
import { TrailerModal } from 'components/modals/TrailerModal';
import { UserModal } from 'components/modals/UserModal';
import { VehicleModal } from 'components/modals/VehicleModal';
import { VideoModal } from 'components/modals/VideoModal';
import { Fragment, useContext, useEffect, useState } from 'react';
import Style from './app.module.scss';
import { EndorsementModalV2 } from 'components/modals/EndorsementModalV2';
import { EndorsementModal } from 'components/modals/EndorsementModal';
import { AppBanner } from 'components/AppBanner';

export function AppLayout(props) {
  const authContext = useContext(AuthContext);
  const user = useAPI('/api/user');

  const [account, setAccount] = useState();
  const [policies, setPolicies] = useState([]);
  const [ticketCount, setTicketCount] = useState(0);
  const [renewalCount, setRenewalCount] = useState(0);
  const [bindRequestCount, setBindRequestCount] = useState(0);

  const location = useLocation();
  const userAccount = authContext.user?.accounts?.find(
    (x) => x.id === authContext.user?.account_id
  );


  const agency = (agencyId) => {
    if (agencyId) {
      const agencyString = 'A000000';
      const count = agencyId.split(' ')[0].length;

      return (
        agencyString.substring(0, agencyString.length - count) +
        agencyId
      );
    }
  };

  useEffect(() => {
    if (user?.data?.account_id) {
      setAccount(user?.data?.account_id);
    }

    if (!account) return;

    const listCounts = async () => {
      try {
        const [ticketsResponse, renewalsResponse, bindRequestsResponse] = await Promise.all([
          axios.get(`/api/tickets/${account}`,
            {
              params: { status: 'Active' }
            }),
          axios.get(`/api/renewals/${account}`,
            {
              params: { status: 'Active' }
            }),
          axios.get(`/api/bind-requests/${account}`,
            {
              params: { status: 'Active' }
            }),
        ]);

        setTicketCount(ticketsResponse.data.total);
        setRenewalCount(renewalsResponse.data.total);
        setBindRequestCount(bindRequestsResponse.data.total);
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    };

    listCounts();
  }, [
    account,
    bindRequestCount,
    renewalCount,
    ticketCount,
    user?.data?.account_id
  ]);

  useEffect(() => {
    (async () => {
      const policies = await axios.get(
        `/api/command-center/policies?page=1&pageSize=1`
      );

      setPolicies(policies.data.data.data.policies);
    })();
  }, []);

  return (
    <Fragment>
      <AppBanner />
      <CompanyModal />
      <ContactModal />
      <DocumentsModal />
      <QuoteDocumentsModal />
      <AgencyDocumentsModal />
      <DriversModal />
      <VehicleModal />
      <TrailerModal />
      <ContestModal />
      <VideoModal />
      <Confirmation />
      <ChooseModal />
      <Options />
      <Warning />
      <CertificatesModal />
      <UserModal />
      {/* <EndorsementModal /> */}
      <RunQuoteModal />
      <RunPersonalQuoteModal />
      <Error />
      <Success />
      <Loading />
      <Acknowledge />
      <CommodityModal />
      <EmailQuoteModal />
      <InvalidCommodity />
      <ExpiredDocument />
      <BindPopup />
      <SubmitModal />
      <EndorsementModalV2 />

      <AppNav
        items={
          policies.length > 0
            ? [
              {
                label: 'Dashboard',
                icon: 'grid',
                link: '/app/dashboard',
              },
              {
                label: 'Service Center',
                icon: 'tool',
                link: '/app/service_center',
                itemsCount: ticketCount,
              },
              {
                label: 'Bind Requests',
                icon: 'file-plus',
                link: '/app/bind-requests',
                itemsCount: bindRequestCount,
              },
              {
                label: 'Renewals',
                icon: 'refresh-cw',
                link: '/app/renewals',
                itemsCount: renewalCount,
              },
              {
                label: 'Companies',
                icon: 'briefcase',
                link: '/app/companies',
              },
              {
                label: 'Quotes',
                icon: 'dollar-sign',
                link: '/app/quote/app',
              },
              {
                label: 'Policies',
                icon: 'file-text',
                link: '/app/policies',
              },
              {
                label: 'Endorsements',
                icon: 'plus-circle',
                link: '/app/endorsements',
              },
              {
                label: 'Certificates',
                icon: 'award',
                link: '/app/certificates',
              },
              {
                label: 'Snapshot',
                icon: 'zap',
                link: '/app/snapshot',
              },
              {
                label: 'Resources',
                icon: 'help-circle',
                link: '/app/resources',
              },
            ]
            : [
              {
                label: 'Dashboard',
                icon: 'grid',
                link: '/app/dashboard',
              },
              {
                label: 'Service Center',
                icon: 'tool',
                link: '/app/service_center',
                itemsCount: ticketCount,
              },
              {
                label: 'Bind Requests',
                icon: 'file-plus',
                link: '/app/bind-requests',
                itemsCount: bindRequestCount,
              },
              {
                label: 'Renewals',
                icon: 'refresh-cw',
                link: '/app/renewals',
                itemsCount: renewalCount,
              },
              {
                label: 'Companies',
                icon: 'briefcase',
                link: '/app/companies',
              },
              {
                label: 'Quotes',
                icon: 'dollar-sign',
                link: '/app/quote/app',
              },
              {
                label: 'Policies',
                icon: 'file-text',
                link: '/app/policies',
              },
              {
                label: 'Snapshot',
                icon: 'zap',
                link: '/app/snapshot',
              },
              {
                label: 'Resources',
                icon: 'help-circle',
                link: '/app/resources',
              },
            ]
        }
        fixedItems={[
          { label: 'Profile', icon: 'user', link: '/app/account' },
        ]}
      />

      <main className={Style.app}>
        <Header title="Cover Badger">
          <User />
        </Header>

        {location.pathname.includes('/app/company') && (
          <div className={Style.agencyInfo}>
            {userAccount
              ? userAccount.name +
              ' - (' +
              agency(JSON.stringify(userAccount.sequence)) +
              ')'
              : 'A000000'}
          </div>
        )}

        {location.pathname.includes('/company') &&
          !location.pathname.includes('/account') && (
            <CustomersHeader />
          )}
        <div
          style={
            location.pathname.includes('/company') &&
              !location.pathname.includes('/account')
              ? { marginTop: 'calc(230px + var(--app-banner-offset, 0px))', zIndex: 2 }
              : { marginTop: 'calc(110px + var(--app-banner-offset, 0px))', zIndex: 2 }
          }
        >
          {<props.children {...props.data} />}
        </div>
      </main>
    </Fragment>
  );
}
